/**
 * Configuración de colores primarios para el tema claro.
 * Usado en la página de configuración cuando el tema es "Claro".
 * Cada color incluye base, contrast, shade y tint según convención de Ionic.
 */
export type ClaveColorPrimario = 'azul' | 'verde' | 'teal';

export interface ColorPrimarioDef {
  clave: ClaveColorPrimario;
  nombre: string;
  hex: string;
  rgb: string;
  contrast: string;
  contrastRgb: string;
  shade: string;
  tint: string;
}

export const COLORES_PRIMARIOS: Record<ClaveColorPrimario, ColorPrimarioDef> = {
  azul: {
    clave: 'azul',
    nombre: 'Azul',
    hex: '#0F69C4',
    rgb: '15, 105, 196',
    contrast: '#ffffff',
    contrastRgb: '255, 255, 255',
    shade: '#0D5EAF',
    tint: '#2780D1',
  },
  verde: {
    clave: 'verde',
    nombre: 'Verde',
    // Verde esmeralda más puro (aleja del cian)
    hex: '#16a34a',
    rgb: '22, 163, 74',
    contrast: '#ffffff',
    contrastRgb: '255, 255, 255',
    shade: '#138f41',
    tint: '#2dac5c',
  },
  teal: {
    clave: 'teal',
    nombre: 'Teal',
    // Cian marcado para no confundirse con verde
    hex: '#0891b2',
    rgb: '8, 145, 178',
    contrast: '#ffffff',
    contrastRgb: '255, 255, 255',
    shade: '#07809c',
    tint: '#219cbc',
  },
};

/** Clave por defecto (azul, mismo que el primario existente). */
export const COLOR_PRIMARIO_DEFAULT: ClaveColorPrimario = 'azul';

/**
 * Devuelve la definición del color primario para una clave.
 */
export function obtenerColorPrimarioDef(clave: ClaveColorPrimario): ColorPrimarioDef {
  return COLORES_PRIMARIOS[clave];
}

/**
 * Aplica las variables CSS de Ionic para el color primario en el documento.
 * Debe llamarse cuando el tema efectivo es claro.
 */
export function aplicarColorPrimarioEnDocumento(clave: ClaveColorPrimario): void {
  const def = obtenerColorPrimarioDef(clave);
  const root = document.documentElement;
  root.style.setProperty('--ion-color-primary', def.hex);
  root.style.setProperty('--ion-color-primary-rgb', def.rgb);
  root.style.setProperty('--ion-color-primary-contrast', def.contrast);
  root.style.setProperty('--ion-color-primary-contrast-rgb', def.contrastRgb);
  root.style.setProperty('--ion-color-primary-shade', def.shade);
  root.style.setProperty('--ion-color-primary-tint', def.tint);
}

/**
 * Restaura el color primario por defecto (azul) en el documento.
 * Útil al pasar a tema oscuro para no dejar variables custom.
 */
export function restaurarColorPrimarioPorDefecto(): void {
  aplicarColorPrimarioEnDocumento(COLOR_PRIMARIO_DEFAULT);
}
